<script setup lang="ts">
import { Ticket } from 'lucide-vue-next'
import Message from 'primevue/message'
import { useI18n } from 'vue-i18n'
import Tools from '@/utils/tools'

const props = withDefaults(defineProps<Props>(), {
	errorCode: '',
	tickets: 0,
	duration: 0,
})

const emit = defineEmits<{
	close: []
}>()

const { t } = useI18n()

interface Props {
	errorCode?: string
	tickets?: number
	duration?: number
}

function handleClose() {
	emit('close')
}
</script>

<template>
	<div class="flex flex-col gap-2">
		<!-- Error or Success Message for Tickets -->
		<Message
			v-if="props.errorCode.length || props.tickets"
			:severity="props.errorCode.length ? 'error' : 'success'"
			class="my-0"
			@close="handleClose"
		>
			<template v-if="props.errorCode.length">
				{{ t(`notification.${props.errorCode}.message`) }}
			</template>
			<i18n-t
				v-else
				scope="global"
				keypath="notification.tickets_added.message"
				tag="span"
			>
				<template #tickets>
					<span class="inline-flex items-center font-extrabold gap-1">
						{{ Tools.formatNumber(props.tickets) }} <Ticket class="lucide-button-icon-sm" />
					</span>
				</template>
			</i18n-t>
		</Message>

		<!-- Success Message for Pro Duration -->
		<Message
			v-if="props.duration > 0"
			severity="success"
			class="my-0"
			@close="handleClose"
		>
			<i18n-t
				scope="global"
				keypath="notification.pro_redeem.message"
				tag="span"
			>
				<template #amount>
					<span class="inline-flex items-center font-extrabold gap-1">
						{{ props.duration }}
					</span>
				</template>
				<template #duration_format>
					<span class="inline-flex items-center font-extrabold gap-1">
						{{ t(`durations.day${props.duration > 1 ? 's' : ''}`) }}
					</span>
				</template>
			</i18n-t>
		</Message>
	</div>
</template>
